<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px;height: auto !important;"
          toggleable="lg" type="dark" variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Document Type Master</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form v-if="
                $sessionsStorage.get('designation') == 'Admin' &&
                $sessionsStorage.get('nameUser') == 'Bhavneesh'
              ">
              <b-button variant="outline-primary" @click="addEditCardFunc()" size="sm">Add</b-button>
              <!-- <b-button
                size="sm"
                class="ml-3"
                @click="getReportsAss('All_Document_Type_Report')"
                variant="outline-info"
                >Export as Excel</b-button
              > -->
              <b-button :disabled="ExcelBtnName != 'Export as Excel' ? true : false" class="ml-3"
                @click="getReportsAss('All_Document_Type_Report', 'Export as Excel')" size="sm"
                variant="outline-info">{{ ExcelBtnName }}
                <b-spinner v-if="ExcelBtnName != 'Export as Excel'" small label="Small Spinner"></b-spinner></b-button>
            </b-nav-form>
          </b-navbar-nav>

          <!-- <b-button
                    v-if="
                        $sessionsStorage.get('designation') == 'Admin' &&
                        $sessionsStorage.get('nameUser') == 'Bhavneesh'
                        "
                    size="sm"
                    class="ml-1"
                    @click="getReports('All_Consignor_Report')"
                    variant="outline-info"
                >Export</b-button>-->
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- Add Update Form Input End-->
            <b-card class="gutr" v-if="addEditCard">
              <b-row class="align-items-end">
                <b-col md="12">
                  <h5>{{ DocumentTypeMaster.documentName }} Document Details</h5>
                </b-col>
                <b-col md="3">
                  <label for="ModuleType">Module Type</label>
                  <model-list-select :list="ModuleTypeList" v-model="DocumentTypeMaster.ModuleType"
                    option-value="ModuleTypeVal" option-text="ModuleTypeTxt"
                    placeholder="Please Select ModuleType"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label for="blType">Document Type Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input :formatter="capitalizeAll" id="documentName" name="documentName"
                    v-model="DocumentTypeMaster.documentName" placeholder="Document Name"></b-form-input>
                  <span class="error" v-if="!DocumentTypeMaster.documentName">
                    {{ errorList.documentName }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>Status :</label>
                  <md-switch :id="'approval' + DocumentTypeMaster.isDocumentActive" name="approval" class="md-primary"
                    :value="DocumentTypeMaster.isDocumentActive == 1 ? true : false"
                    @change="activateDocumentTypeMaster()">
                    <h6>
                      <b-badge :variant="
                          DocumentTypeMaster.isDocumentActive == 1 ? 'success' : 'danger'
                        ">{{
                        DocumentTypeMaster.isDocumentActive == 1
                        ? "Active"
                        : "In-Active"
                        }}</b-badge>
                    </h6>
                  </md-switch>
                </b-col>
                <b-col md="6" id="descriptionDiv" style="display:block;"
                  v-if="DocumentTypeMaster.ModuleType == 'Pridel Document'">
                  <label> Description </label>
                  <b-form-textarea :formatter="capitalizeAll" id="description" name="description"
                    v-model="DocumentTypeMaster.description"></b-form-textarea>
                </b-col>
                <b-col md="12">
                  <center>
                    <b-button style="margin-bottom: 0.3rem" variant="success" @click="addDocumentTypeMaster"
                      class="mt-2" id="addButtonLoader">
                      {{ DocumentTypeMaster.documentTypeId ? "Update" : "Save" }}
                    </b-button>
                  </center>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
              </b-row>
            </b-card>
            <!-- Add Update Form Input End-->

            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="10" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                        placeholder="Type to Search Consignor Master and Code" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <h5>
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5>
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="All_Document_Type_List_data" :fields="fields"
                  :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" responsive
                  primary-key="stateId" class="position-relative">
                  <template slot="agntColoader" slot-scope="row0">
                    <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="categoryType" slot-scope="row1">
                    <span @click="
                        $sessionsStorage.get('designation') == 'Admin' &&
                        $sessionsStorage.get('nameUser') == 'Bhavneesh'
                          ? viewEdit(row1.item)
                          : ''
                      " class="showMoreData">{{ row1.item.categoryType }}</span>
                  </template>
                  <template slot="ModuleType" slot-scope="row55">
                    <span>{{
                      row55.item.ModuleType != "" ? row55.item.ModuleType : "--"
                      }}</span>
                  </template>
                  <template slot="documentName" slot-scope="row11">
                    <span>{{
                      row11.item.documentName != "" ? row11.item.documentName : "--"
                      }}</span>
                  </template>
                  <template slot="isDocumentActive" slot-scope="row22">
                    <div v-if="adminToggle == 'Admin'" :id="'row' + row22.item.documentTypeId">
                      <md-switch :id="'approval' + row22.item.documentTypeId" name="approval" class="md-primary"
                        :value="row22.item.isDocumentActive == 1 ? true : false"
                        @change="activateDocumentTypeUser(row22.item)">
                        <h6>
                          <br />
                          <b-badge style="margin-left: -45px">{{
                            row22.item.isDocumentActive == 1 ? "Active" : "In-Active"
                            }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row' + row22.item.documentTypeId">
                      <h6>
                        <b-badge>{{
                          row22.item.isDocumentActive == 1 ? "Active" : "In-Active"
                          }}</b-badge>
                      </h6>
                    </div>
                  </template>

                  <template slot="action" slot-scope="row2">
                    <b-button variant="outline-primary" @click="editDocumentTypeMaster(row2.item)" id="addButtonLoader"
                      size="sm">Update</b-button>
                  </template>
                  <template slot="companyName" slot-scope="row14">
                    <span>
                      Company Name : {{ row14.item.companyName }}
                      <br />
                    </span>
                    <span>
                      Address : {{ row14.item.address }}
                      <br />
                    </span>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="5" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
import ClientUserService from "../../services/ClientUserService.js";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/DocumentTypeMaster");
      if (globalPermissionStatus("Document Type") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("Document Type")
        );
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
      this.getAllDocumentTypeMasterList();
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      addEditCard: false,
      isLoading: false,
      fields: [
        {
          key: "documentTypeId",
          label: "SN",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "ModuleType",
          label: "Module Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "documentName",
          label: "Document Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "description",
          label: "Description",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "isDocumentActive",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "action",
          label: "Actions",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      ExcelBtnName: "Export as Excel",
      currentPage: 1,
      perPage: 10,
      adminToggle: this.$sessionsStorage.get("designation"),
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      ModuleTypeList: [
        {
          ModuleTypeVal: "Pridel Document",
          ModuleTypeTxt: "Pridel Document",
        },
        {
          ModuleTypeVal: "Sline",
          ModuleTypeTxt: "Sline",
        },
        {
          ModuleTypeVal: "Expense Port",
          ModuleTypeTxt: "Expense Port",
        },
        {
          ModuleTypeVal: "Expense",
          ModuleTypeTxt: "Expense",
        },
      ],
      DocumentTypeMaster: {
        documentTypeId: "",
        ModuleType: "Pridel Document",
        documentName: "",
        description: "",
        isDocumentActive: true,
        TypeofAdd: "Document Master Add",
      },
      DocumentTypeMasterError: ["Please Enter Document Name"],
      errorList: {
        documentName: "",
      },
      All_Document_Type_List_data: [],
      validate: true,
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    HideShowDescription(item){
      if(item != '' && item != 'Pridel Document') {
        $('#descriptionDiv').hide();
      } else {
        $('#descriptionDiv').show();
      }
    },
    activateDocumentTypeMaster() {
      if (
        this.DocumentTypeMaster.isDocumentActive == 1 ||
        this.DocumentTypeMaster.isDocumentActive == true
      ) {
        this.DocumentTypeMaster.isDocumentActive = false;
      } else if (
        this.DocumentTypeMaster.isDocumentActive == 0 ||
        this.DocumentTypeMaster.isDocumentActive == false
      ) {
        this.DocumentTypeMaster.isDocumentActive = true;
      }
    },
    validateRefuelStation() {
      let validate_new = true;

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    activateDocumentTypeUser(item, index) {
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.isDocumentActive = this.itemObj.isDocumentActive == 1 ? 0 : 1;
      let paylod = {
        tableName: "documentType_master",
        tableId: "documentTypeId",
        tableIsActive: "isDocumentActive",
        value1: this.itemObj.isDocumentActive,
        tableVal: item.documentTypeId,
        isMailSend:'No',
         manual:'No',
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    validateDocumentTypeMaster() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (
          this.DocumentTypeMaster[x] == "" ||
          this.DocumentTypeMaster[x] == undefined ||
          this.DocumentTypeMaster[x] == null
        ) {
          console.log("this.DocumentTypeMaster[x]=>", this.DocumentTypeMaster);
          this.errorList[x] = this.DocumentTypeMasterError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },
    addDocumentTypeMaster() {
      this.validateDocumentTypeMaster();
      this.DocumentTypeMaster.TypeofAdd = "Document Type Master Add";
      if (this.validate == false) return false;
      this.isLoading = true;

      let payload = {
        itemCode: "add_Document_Type_Details",
        DocumentTypeMaster: this.DocumentTypeMaster,
      };
      payload = JSON.stringify(payload);
      if (this.validate != false) {
        CommonService.getAllCommonMaster(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (data.documentTypeId != "" && data.documentTypeId != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.getAllDocumentTypeMasterList();
              this.addEditCardFunc();
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch((error) => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },
    getReportsAss(id, btnName) {
      let excelIdGivin = "";
      if (id == "All_Document_Type_Report") {
        excelIdGivin = "All_Document_Type_Report";
      }
      let payload = {
        excelId: excelIdGivin,
        assignmentNo: "DocumentType",
      };
      this.ExcelBtnName = "Downloading Please Wait..";
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        this.ExcelBtnName = btnName;
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
      }
    },
    clearErrVal() {
      this.DocumentTypeMaster = {
        ModuleType: "Pridel Document",
        documentName: "",
        description: "",
        isDocumentActive: true,
        TypeofAdd: "Document Master Add",
      };
    },
    getAllDocumentTypeMasterList() {
      this.isLoading = true;
      let payload = {
        itemCode: "All_Document_Type_List",
        Filter: this.Filter,
      };
      // JSON.stringify();
      // await
      CommonService.getAllCommonMaster(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.All_Document_Type_List_data = data.All_Document_Type_List_data;
            this.totalRows = data.All_Document_Type_List_data.length;
            console.log("All_Document_Type_List response=>", data);
          } else {
            this.All_Document_Type_List_data = [];
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_Document_Type_List Error: ", error);
        });
    },

    editDocumentTypeMaster(item) {
      this.clearErrVal();
      this.addEditCard = true;
      item.TypeofAdd = "Document Type Master Update";
      this.DocumentTypeMaster = item;
      this.setFocus();
    },
    addEditCardFunc() {
      this.clearErrVal();
      this.addEditCard = !this.addEditCard;
    },
    setFocus: function () {
      // Note, you need to add a ref="search" attribute to your input.
      this.$refs.search.focus();
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllDocumentTypeMasterList();
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.getAllDocumentTypeMasterList();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {
      return $(function () {
        return $("#portLocationNew").DataTable();
      });
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// documentTypeMaster.vue?4055ab2c